module.exports = name => name && name.trim().split(' ').length >= 2
